export default () => ({
  1553697337596: {
    id: 1553697337596,
    titulo: 'Verificação',
    perguntas: {
      1553697343865: {
        id: 1553697343865,
        titulo: 'Atendeu a notificação?',
        tipo: 'sim_nao',
        obrigatorio: true,
        min_fotos: 2,
        acoes: [
          { op: { eq: true }, run: ['notificacao.autorizar_desconto'] },
          { op: { eq: false }, run: ['notificacao.negar_desconto'] },
        ],
      },
    },
  },
})
